import { render, staticRenderFns } from "./header.vue?vue&type=template&id=f1770ec6&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=f1770ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1770ec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1770ec6')) {
      api.createRecord('f1770ec6', component.options)
    } else {
      api.reload('f1770ec6', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=f1770ec6&scoped=true&", function () {
      api.rerender('f1770ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/template/shared/header.vue"
export default component.exports